<template>
    <div class="main">
        会员服务
    </div>
</template>

<script>
export default {

    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {}

}

</script>

<style lang="scss" scoped>
h1 {
    width: 100px;
}
</style>
